export default __webpack_public_path__ + "static/media/Giuliano Malatesta.29e58b8e.jpg";